const m = window.require("discourse/lib/swipe-events");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;